/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import {
  successColor,
  tooltip,
  cardTitle,
  blackColor,
  grayColor,
  dangerColor,
  warningColor,
  infoColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.jsx";

import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.jsx";

const dashboardStyle = {
  ...hoverCardStyle,
  tooltip,
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    color: 'white',
    fontSize: '1.3em',
    fontWeight: '600',
  },
  titleLogoContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  titleLogo: {
    width: 30,
    height: 30,
    marginRight: 8,
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center"
  },
  cardCategory: {
    color: grayColor[0],
    fontSize: "14px",
    paddingTop: "10px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0"
  },
  cardProductDesciprion: {
    textAlign: "center",
    color: grayColor[0]
  },
  stats: {
    color: grayColor[0],
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px"
    }
  },
  bottomDescription: {
    color: grayColor[0],
    fontSize: "12px",
    lineHeight: "22px",
    // display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px"
    }
  },
  productStats: {
    paddingTop: "7px",
    paddingBottom: "7px",
    margin: "0"
  },
  successText: {
    color: successColor[0]
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  },
  underChartIcons: {
    width: "17px",
    height: "17px"
  },
  price: {
    color: "inherit",
    "& h4": {
      marginBottom: "0px",
      marginTop: "0px"
    }
  },
  grid: {
    padding: "0 15px !important"
  },
  graphStyle: {
    '& .ct-label': { fill: 'red' },
  },
  averageArea: {
    display: "flex",
    justifyContent: "center"
  },
  averageBox: {
    width: 200,
    textAlign: 'center',
    // marginTop: 10,
    marginBottom: 30,
    padding: 8,
    color: grayColor[0],
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .14)"
  },
  rowDirection: {
    display: "flex",
    justifyContent: "space-between"
  },
  legendBox: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.7em",
    margin: 8,
    color: grayColor[0],
  },
  legendInfoBox: {
    width: 20,
    height: 6,
    backgroundColor: infoColor[0],
    marginLeft: 8,
    marginRight: 8,
  },
  legendDangerBox: {
    width: 20,
    height: 6,
    backgroundColor: dangerColor[0],
    marginLeft: 8,
    marginRight: 8,
  },
  legendGrayBox: {
    width: 20,
    height: 6,
    backgroundColor: grayColor[0],
    marginLeft: 8,
    marginRight: 8,
  },
  legendWarningBox: {
    width: 20,
    height: 6,
    backgroundColor: warningColor[0],
    marginLeft: 8,
    marginRight: 8,
  },
  cardHeader: {
    flex: 1,
    justifyContent: 'flex-begin !important',
    alignItems: 'flex-begin !important',
  },
  cardBody: {
    marginTop: 20,
    width: '100%',
    height: '100%'
  },
  cardFooter: {
    marginTop: "0px !important",
    justifyContent: 'flex-begin !important',
    alignItems: 'flex-begin !important',
    width: '100%',
    height: '100%',
    paddingLeft: 20,
  }
};

export default dashboardStyle;
